import { useNavigate } from '@tanstack/react-router'
import { useTelegram } from '@/shared/lib/telegram'
import { ArrowRight } from 'lucide-react'

import { useDrinkHistory } from '@/features/drink-history/api/use-drink-history'

/**
 * Виджет: Футер контента главной страницы
 * 
 * Мягкая подсказка о чайном дневнике с ссылкой на дневник.
 * Показывается только если есть хотя бы одна запись.
 */
export function HomeFooter() {
  const navigate = useNavigate()
  const { hapticFeedback } = useTelegram()
  const { data } = useDrinkHistory({ limit: 1 })
  
  const hasEntries = (data?.data?.length || 0) > 0
  
  const handleClick = () => {
    hapticFeedback.impactOccurred('light')
    navigate({ to: '/tea-diary' })
  }
  
  if (!hasEntries) {
    return null
  }
  
  return (
    <div className="px-4 pb-6">
      <button
        onClick={handleClick}
        className="w-full text-left px-4 py-3 bg-gray-50 dark:bg-dark-card rounded-xl border border-silk/50 dark:border-dark-border/50 hover:bg-gray-100 dark:hover:bg-dark-elevated active:bg-gray-200 dark:active:bg-dark-elevated transition-colors touch-target shadow-sm dark:shadow-md"
        style={{ minHeight: '44px' }}
      >
        <p className="text-sm text-gray-600 dark:text-gray-300 flex flex-wrap items-center gap-x-2 gap-y-1">
          <span className="whitespace-nowrap">Весь ваш чайный путь — в дневнике.</span>
          <span className="text-primary dark:text-primary-light font-medium inline-flex items-center gap-1 whitespace-nowrap">
            Открыть дневник
            <ArrowRight className="h-3.5 w-3.5 flex-shrink-0" />
          </span>
        </p>
      </button>
    </div>
  )
}
